import React, { Component } from 'react';
import API_CONFIG from '../config/api';

class RequestServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: '',
        email: '',
        company: '',
        service: 'ai-consulting',
        message: ''
      },
      isSubmitting: false,
      submitStatus: null,
      submitMessage: ''
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value
      }
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isSubmitting: true, submitStatus: null, submitMessage: '' });

    try {
      const apiUrl = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.REQUEST_SERVICES}`;
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.state.formData)
      });

      if (response.ok) {
        this.setState({
          submitStatus: 'success',
          submitMessage: 'Thank you! Your request has been submitted successfully. We will contact you soon.',
          formData: {
            name: '',
            email: '',
            company: '',
            service: 'ai-consulting',
            message: ''
          }
        });
      } else {
        throw new Error('Failed to submit request');
      }
    } catch (error) {
      this.setState({
        submitStatus: 'error',
        submitMessage: 'Sorry, there was an error submitting your request. Please try again later.'
      });
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    const { formData, isSubmitting, submitStatus, submitMessage } = this.state;

    const containerStyle = {
      padding: '20px',
      maxWidth: '900px',
      margin: '0 auto',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      lineHeight: '1.6'
    };

    const headerStyle = {
      textAlign: 'center',
      color: '#1f2937',
      marginBottom: '40px',
      fontSize: '32px',
      fontWeight: '700'
    };

    const sectionStyle = {
      backgroundColor: '#fff',
      border: '1px solid #e5e7eb',
      borderRadius: '10px',
      padding: '30px',
      margin: '20px 0',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    };

    const serviceCardStyle = {
      backgroundColor: '#f9fafb',
      border: '1px solid #e5e7eb',
      borderRadius: '8px',
      padding: '20px',
      margin: '15px 0'
    };

    const formGroupStyle = {
      marginBottom: '20px'
    };

    const labelStyle = {
      display: 'block',
      color: '#374151',
      fontWeight: '600',
      marginBottom: '8px',
      fontSize: '14px'
    };

    const inputStyle = {
      width: '100%',
      padding: '12px',
      border: '1px solid #d1d5db',
      borderRadius: '5px',
      fontSize: '16px',
      boxSizing: 'border-box',
      fontFamily: 'inherit'
    };

    const selectStyle = {
      ...inputStyle,
      backgroundColor: 'white'
    };

    const textareaStyle = {
      ...inputStyle,
      minHeight: '120px',
      resize: 'vertical'
    };

    const buttonStyle = {
      backgroundColor: isSubmitting ? '#9ca3af' : '#2563eb',
      color: 'white',
      border: 'none',
      padding: '14px 32px',
      borderRadius: '5px',
      cursor: isSubmitting ? 'not-allowed' : 'pointer',
      fontSize: '16px',
      fontWeight: '600',
      width: '100%',
      transition: 'background-color 0.3s'
    };

    const alertStyle = {
      padding: '15px',
      borderRadius: '5px',
      marginBottom: '20px',
      textAlign: 'center',
      fontWeight: '500'
    };

    const successStyle = {
      ...alertStyle,
      backgroundColor: '#d1fae5',
      color: '#065f46',
      border: '1px solid #6ee7b7'
    };

    const errorStyle = {
      ...alertStyle,
      backgroundColor: '#fee2e2',
      color: '#991b1b',
      border: '1px solid #fca5a5'
    };

    const profileImageStyle = {
      width: '150px',
      height: '150px',
      borderRadius: '50%',
      margin: '0 auto 30px',
      display: 'block',
      border: '4px solid #2563eb',
      objectFit: 'cover',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
    };

    return (
      <div style={containerStyle}>
        <img 
          src="/profile_photo.jpg" 
          alt="Jake Dahl" 
          style={profileImageStyle}
        />
        <h1 style={headerStyle}>Bring Your Ideas to Life</h1>
        
        <div style={sectionStyle}>
          <h2 style={{ color: '#1f2937', marginBottom: '20px', fontSize: '24px', textAlign: 'center' }}>
            ✨ I Turn Dreams Into Reality
          </h2>
          <p style={{ color: '#4b5563', fontSize: '18px', marginBottom: '20px', textAlign: 'center' }}>
            Have an idea? A vision? Something you've been dreaming about building?
          </p>
          <p style={{ color: '#4b5563', fontSize: '18px', textAlign: 'center' }}>
            I specialize in taking your concepts and making them real. Whether it's powered by AI, 
            needs a web presence, or requires custom technology solutions - I'll help you build it.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={{ color: '#1f2937', marginBottom: '20px', fontSize: '24px' }}>
            🚀 What I Do
          </h2>

          <div style={serviceCardStyle}>
            <h3 style={{ color: '#1f2937', marginBottom: '12px', fontSize: '20px' }}>
              🤖 AI Solutions
            </h3>
            <p style={{ color: '#4b5563', marginBottom: '10px' }}>
              Want to add AI to your project? I can help you integrate intelligent features 
              that understand language, recognize images, make predictions, or automate complex tasks.
            </p>
            <p style={{ color: '#6b7280', fontSize: '14px', fontStyle: 'italic' }}>
              Perfect for: chatbots, automation, smart recommendations, data analysis, and more.
            </p>
          </div>

          <div style={serviceCardStyle}>
            <h3 style={{ color: '#1f2937', marginBottom: '12px', fontSize: '20px' }}>
              💻 Technology Solutions
            </h3>
            <p style={{ color: '#4b5563', marginBottom: '10px' }}>
              Need a website, iOS app, Android app, or system built? I create everything from simple sites 
              to complex mobile applications that run in the cloud and scale with your needs.
            </p>
            <p style={{ color: '#6b7280', fontSize: '14px', fontStyle: 'italic' }}>
              Perfect for: websites, iOS apps, Android apps, web apps, APIs, databases, cloud infrastructure, and custom software.
            </p>
          </div>

          <div style={{ backgroundColor: '#eff6ff', borderLeft: '4px solid #2563eb', padding: '20px', borderRadius: '5px', margin: '20px 0' }}>
            <p style={{ color: '#1f2937', fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
              💡 The Bottom Line
            </p>
            <p style={{ color: '#4b5563' }}>
              You have the vision. I have the skills. Together, we'll create something amazing.
            </p>
          </div>
        </div>

        <div style={sectionStyle}>
          <h2 style={{ color: '#1f2937', marginBottom: '20px', fontSize: '24px' }}>
            📋 Let's Talk About Your Project
          </h2>
          <p style={{ color: '#4b5563', marginBottom: '25px' }}>
            Tell me about your idea. No matter how big or small, I'd love to hear about it 
            and explore how we can make it happen.
          </p>

          {submitStatus && (
            <div style={submitStatus === 'success' ? successStyle : errorStyle}>
              {submitMessage}
            </div>
          )}

          <form onSubmit={this.handleSubmit}>
            <div style={formGroupStyle}>
              <label style={labelStyle} htmlFor="name">
                Your Name *
              </label>
              <input
                style={inputStyle}
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={this.handleInputChange}
                required
                placeholder="John Doe"
              />
            </div>

            <div style={formGroupStyle}>
              <label style={labelStyle} htmlFor="email">
                Email Address *
              </label>
              <input
                style={inputStyle}
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={this.handleInputChange}
                required
                placeholder="john@example.com"
              />
            </div>

            <div style={formGroupStyle}>
              <label style={labelStyle} htmlFor="company">
                Company/Organization (Optional)
              </label>
              <input
                style={inputStyle}
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={this.handleInputChange}
                placeholder="Your Company Name"
              />
            </div>

            <div style={formGroupStyle}>
              <label style={labelStyle} htmlFor="service">
                What are you interested in? *
              </label>
              <select
                style={selectStyle}
                id="service"
                name="service"
                value={formData.service}
                onChange={this.handleInputChange}
                required
              >
                <option value="ai-consulting">AI Solutions</option>
                <option value="it-consulting">Technology Solutions</option>
                <option value="both">Both AI & Technology</option>
                <option value="other">Not sure yet / Other</option>
              </select>
            </div>

            <div style={formGroupStyle}>
              <label style={labelStyle} htmlFor="message">
                Tell me about your idea *
              </label>
              <textarea
                style={textareaStyle}
                id="message"
                name="message"
                value={formData.message}
                onChange={this.handleInputChange}
                required
                placeholder="Describe your project, idea, or vision. What are you trying to build? What problem are you solving?"
              />
            </div>

            <button
              type="submit"
              style={buttonStyle}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send My Request'}
            </button>
          </form>
        </div>

        <div style={sectionStyle}>
          <h3 style={{ color: '#1f2937', marginBottom: '15px' }}>
            📬 What Happens Next?
          </h3>
          <ul style={{ color: '#4b5563', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>
              I'll review your request within 24-48 hours
            </li>
            <li style={{ marginBottom: '8px' }}>
              We'll set up a time to chat about your project
            </li>
            <li style={{ marginBottom: '8px' }}>
              I'll share my thoughts and a plan for bringing it to life
            </li>
            <li style={{ marginBottom: '8px' }}>
              Everything discussed is confidential
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default RequestServices;
